export const service = [
  'Test your business idea',
  'Build your digital product',
  'Grow your product',
  'Support for your product',
  'Technologies',
];
